export const useBuffer = () => {
	function buffer2Base64(arrayBuffer, mimetype = 'image/jpeg') {
		if (typeof arrayBuffer === 'undefined') return undefined
		const b64encoded = btoa(
			[].reduce.call(
				new Uint8Array(arrayBuffer),
				function (p, c) {
					return p + String.fromCharCode(c)
				},
				''
			)
		)
		return 'data:' + mimetype + ';base64,' + b64encoded
	}
	return {
		buffer2Base64,
	}
}
